import styles from "./EducationMileStone.module.css";
import { monthsFromSubmittedDate } from "../../../../Utils/util";
const EducationMileStone = ({ milestone }) => {
  const hasPresent = milestone.highlights && milestone.highlights.includes("Duration : {month} Months");
  const currentMonth = monthsFromSubmittedDate("Feb 2024")
  return (
    <li className={styles.EducationMileStone}>
      <div className={styles.content}>
        <h2>{milestone.title}</h2>
        <p>{milestone.address} </p>
        {hasPresent ? (
        <div>
        {milestone.highlights && milestone.highlights.map((highlight, index) => {
          return index === 1 ? (
            <p key={index} className={styles.highlight}>
              {highlight.replace("{month}", currentMonth)}
            </p>
          ) : (
            <p key={index} className={styles.highlight}>
              {highlight}
            </p>
          );
        })}
      </div>
      ) : (
        <div>
        
          {milestone.highlights && milestone.highlights.map((highlight) => (
            <p key={highlight} className={styles.highlight}>
              {highlight}
            </p>
          ))}
        </div>
      )}
      </div>
      <div className={styles.time}>
        <h4>{milestone.year}</h4>
      </div>
    </li>
  );
};

export default EducationMileStone;
